export const DISCOUNT_VIEW_ROUTES = {
  campaign: '/services/promotion-center/campaign/:cycleId'
} as const;

export const DISCOUNT_VIEW_PAGE_SIZE = 10;

export const DISCOUNT_VIEW_STATUS_LABELS: Record<string, string> = {
  in_ddc: 'فعال',
  in_edsc: 'قابل ویرایش',
  done: 'پایان یافته'
};
